<template>
  <div class="p-12">
    <div class="max-w-5xl mx-auto">
      <div class="space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500">Projects</h4>
        </div>

        <ProjectFilters />

        <BaseAdvancedList
          searchable
          :loading="loading"
          :with-list-header="listHeader"
          :with-list-item="listItem"
          :entities="projects"
          :meta="meta"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import ProjectFilters from '@/components/Projects/ProjectFilters.vue';
import ListHeader from '@/components/Projects/ListHeader.vue';
import ListItem from '@/components/Projects/ListItem.vue';

export default {
  name: 'AccountProjectsView',
  components: {
    ProjectFilters,
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapState('ui/projects', ['meta']),
    ...mapGetters('ui/projects', ['projects']),
    listHeader() {
      return ListHeader;
    },
    listItem() {
      return ListItem;
    },
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('ui/projects', {
      loadProjects: 'load',
    }),
    ...mapMutations('ui/projects', ['setIds', 'setMeta', 'setLinks']),
    async fetchData() {
      const { query } = this.$route;

      this.loading = true;
      try {
        await this.loadProjects({
          params: {
            ...query,
            include: 'pendingApprovalRequestsCount,owner,accountRelation,client,cover',
          },
        });
      } catch (error) {
        //
      }
      this.loading = false;
    },
  },
};
</script>
